import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const fieldModule = {
  namespaced: true,
  state: {
    // 基本資訊
    basicInfoList: Array.from({ length: 1 }).map((_, index) => ({
      // TODO: 待串接資料移除假資料
      id: Math.floor(Math.random() * 900),
      code: index + 1,
      name: 'ＸＸ社區',
      county: 'ＸＸ縣',
      area: 'ＸＸ區',
      address: 'ＸＸ路ＸＸ號',
      principal: '王ＸＸ',
      tel: '0912-123123',
      account: '0912-123123',
      equipmentNums: 25,
      enabledDate: 'xxxx/xx/xx'
    })),
    dataList: Array.from({ length: 10 }).map((_, index) => ({
      // TODO: 待串接資料移除假資料
      id: Math.floor(Math.random() * 900),
      building: 'A棟',
      floor: `${index + 1} F`,
      district: '花園區、公共區、大廳',
      equipmentNums: 50,
      connectNums: 25,
      disconnectNums: 25,
      floorPlan: Math.random() < 0.5 ? true : false
    })),
    formData: {
      id: null,
      building: '',
      buildingname: '',
      floor: '',
      area: '',
      district: []
    },
    districtList: [],
    // 使用在設備id對應平面圖位置，
    deviceMap: {},
    floorPlanMap: {},
    editWidgets: []
  },
  getters: {
    getBasicInfoList: (state) => state.basicInfoList,
    getDataList: (state) => state.dataList,
    getFormData: (state) => state.formData,
    getDistrictList: (state) => state.districtList,
    getDeviceMap: (state) => state.deviceMap,
    getFloorPlanMap: (state) => state.floorPlanMap,
    getEditWidgets: (state) => state.editWidgets
  },
  mutations: {
    setBasicInfoList(state, newBasicInfoList) {
      state.basicInfoList = newBasicInfoList
    },
    setDataList(state, newDataList) {
      state.dataList = newDataList
    },
    UPDATE_OPERATE_DATA(state, { formData }) {
      Object.entries(formData).forEach(([key, value]) => {
        if (key in state.formData) {
          if (key === 'district') {
            console.log(value)
            if (value === '') {
              state.districtList = []
            } else {
              state.districtList = value.split('、').map((district) => ({
                id: Math.floor(Math.random() * 500),
                label: district,
                value: district,
                flag: false
              }))
            }
          } else {
            state.formData[key] = value
          }
        }
      })
    },
    /** 新增 區域標籤 */
    ADD_DISTRICT_TAG(state, payload) {
      state.districtList.push(payload)
    },
    /** 刪除 區域標籤 */
    DELETE_DISTRICT_TAG(state, payload) {
      const index = state.districtList.indexOf(payload)
      if (index !== -1) {
        state.districtList.splice(index, 1)
      }
    },
    /** 修改 區域標籤 */
    EDIT_DISTRICT_TAG(state, { oldTag, newTag }) {
      const index = state.districtList.findIndex((tag) => tag.id === oldTag.id)
      if (index !== -1) {
        state.districtList.splice(index, 1, newTag)
      }
    },
    /** 切換編輯 區域標籤 狀態 */
    TOGGLE_DISTRICT_TAG_FLAG(state, payload) {
      const tag = state.districtList.find((t) => t.id === payload.id)
      if (tag) {
        tag.flag = !tag.flag
      }
    },
    // 存入平面圖資訊
    SET_GROUP_DATASTORE_LIST(state, payload) {
      state.deviceMap = {}
      state.floorPlanMap = {}
      state.editWidgets.length = 0
      if (payload.deviceMap) {
        state.deviceMap = payload.deviceMap
      }
      if (payload.floorPlanMap) {
        state.floorPlanMap = payload.floorPlanMap
      }
    },
    SET_EDIT_WIDGETS(state, payload) {
      state.editWidgets = payload
    }
  },
  actions: {
    UPDATE_OPERATE_DATA({ commit }, payload) {
      const { formData } = payload
      commit('UPDATE_OPERATE_DATA', { formData })
    },
    ADD_DISTRICT_TAG({ commit }, payload) {
      commit('ADD_DISTRICT_TAG', payload)
    },
    DELETE_DISTRICT_TAG({ commit }, payload) {
      commit('DELETE_DISTRICT_TAG', payload)
    },
    EDIT_DISTRICT_TAG({ commit }, payload) {
      commit('EDIT_DISTRICT_TAG', payload)
    },
    TOGGLE_DISTRICT_TAG_FLAG({ commit }, payload) {
      commit('TOGGLE_DISTRICT_TAG_FLAG', payload)
    },
    // 根據樓層編號取得樓層資訊
    GET_FLOOR_INFO(_, { floorId }) {
      // 回到頁面處理
      return baseFetch(
        API.getFloorInfoByFloorId.url(floorId),
        API.getFloorInfoByFloorId.method,
      )
    },
    // 修改場域平面圖
    UPDATE_FLOOR_PLAN(_, { floorId, ...bodyData }) {
      // 回到頁面處理
      return baseFetch(
        API.updateFloorPlanByFloorId.url(floorId),
        API.updateFloorPlanByFloorId.method,
        bodyData
      )
    },
    // 新增groupDataStore 平面圖相關資料
    SET_GROUP_DATASTORE({ commit, rootState }, { dataName, ...bodyData }) {
      const groupId = rootState.commonModule.currentCommunityId
      // 回到頁面處理
      return baseFetch(
        API.setGroupDataStore.url(groupId, dataName),
        API.setGroupDataStore.method,
        bodyData
      )
    },
    // 取得GroupDataStore 平面圖相關資料
    async LIST_GROUP_DATASTORE({ commit, rootState }, { dataName }) {
      const groupId = rootState.commonModule.currentCommunityId
      try {
        const res = await baseFetch(
          API.listGroupDataStore.url(groupId, dataName),
          API.listGroupDataStore.method,
        )
        if (!res.isError && res.data) {
          // console.log('dataStore:'+JSON.stringify(res.data))
          commit('SET_GROUP_DATASTORE_LIST', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 刪除GroupDataStore 平面圖相關資料
    DELETE_GROUP_DATASTORE({ commit, rootState }, { dataName, dataKey }) {
      const groupId = rootState.commonModule.currentCommunityId
      // 回到頁面處理
      return baseFetch(
        API.delGroupDataStore.url(groupId, dataName, dataKey),
        API.delGroupDataStore.method,
      )
    },
    // 更新GroupDataStore 平面圖相關資料
    UPDATE_GROUP_DATASTORE({ commit, rootState }, { dataName, ...bodyData }) {
      const groupId = rootState.commonModule.currentCommunityId
      // 回到頁面處理
      return baseFetch(
        API.updateGroupDataStore.url(groupId, dataName),
        API.updateGroupDataStore.method,
        bodyData
      )
    },
  }
}

export default fieldModule
